import { useState } from 'react';
import Button from '../../../components/ui/Button';

interface NumericResponseProps {
  disabled?: boolean;
  submitted?: boolean;
  onSubmit: (payload: { value: number }) => void;
}

// Numeric response — {value} payload. Used for relay counts, checkpoint
// numbers, and measurement reads.
//
// /class live redesign (2026-09-11): 16 px input text (`text-base`), not
// 14 px. Below 16 px, iOS Safari zooms the whole page in when the field takes
// focus and leaves the student pinched into a corner of the question — on the
// iPad this feature is aimed at, that alone made the control feel broken. The
// field and its Submit stack on a phone and sit side by side from `sm` up.
export default function NumericResponse({ disabled, submitted, onSubmit }: NumericResponseProps) {
  const [value, setValue] = useState('');

  const submit = () => {
    const n = Number(value);
    if (value.trim() === '' || Number.isNaN(n)) return;
    onSubmit({ value: n });
  };

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
      <input
        type="number"
        inputMode="decimal"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={disabled}
        placeholder="0"
        // WIP-007: a placeholder is not an accessible name (WCAG 3.3.2 / 4.1.2)
        // — this input had no label at all otherwise.
        aria-label="Your numeric answer"
        className="h-12 w-full rounded-lg border border-ws-border bg-ws-surface px-3 text-base text-ws-ink focus:border-ws-accent focus:outline-none disabled:cursor-not-allowed disabled:opacity-60 sm:w-40"
      />
      <Button
        size="lg"
        className="w-full sm:w-auto"
        disabled={disabled || value.trim() === ''}
        onClick={submit}
      >
        {submitted ? 'Update answer' : 'Submit'}
      </Button>
    </div>
  );
}
